
// FOR THE CUSTOM PAGINATION 


(function () {
  function initCounter(carousel) {
    if (carousel.dataset.counterInitialized === 'true') return;

    const wrapper = carousel.parentElement;
    const counterCurrent = wrapper.querySelector('.resource-list__counter-current');
    const counterTotal = wrapper.querySelector('.resource-list__counter-total');

    const slideshow = carousel.matches('slideshow-component')
      ? carousel
      : carousel.querySelector('slideshow-component');

    if (!counterCurrent || !counterTotal || !slideshow) return;

    carousel.dataset.counterInitialized = 'true';

    // const productsPerView = 2;
    const perViewSource = carousel.closest('[data-mobile-per-view]');
    const productsPerView = perViewSource
      ? parseInt(perViewSource.dataset.mobilePerView, 10) || 2
      : 2;
    const slides = slideshow.querySelectorAll('slideshow-slide.resource-list__slide');
    const totalProducts = slides.length;
    const totalPages = Math.ceil(totalProducts / productsPerView);

    counterTotal.textContent = totalPages;

    function updateCounter(index) {
      const currentPage = Math.floor(index / productsPerView) + 1;
      counterCurrent.textContent = Math.min(currentPage, totalPages);
    }

    updateCounter(slideshow.current || 0);

    slideshow.addEventListener('slideshow:select', function (event) {
      if (event.detail && typeof event.detail.index === 'number') {
        updateCounter(event.detail.index);
      }
    });
  }

  function scanForCarousels() {
    document.querySelectorAll('.resource-list__carousel').forEach(initCounter);
  }

  // Initial page load
  scanForCarousels();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanForCarousels);
  }
  document.addEventListener('shopify:section:load', scanForCarousels);

  // Critical: catch carousels injected later via morph() (e.g. predictive search results)
  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        scanForCarousels();
        break;
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();